/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BestSellingItem } from './BestSellingItem';
import {
    BestSellingItemFromJSON,
    BestSellingItemFromJSONTyped,
    BestSellingItemToJSON,
} from './BestSellingItem';
import type { Related } from './Related';
import {
    RelatedFromJSON,
    RelatedFromJSONTyped,
    RelatedToJSON,
} from './Related';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface BestSellingFullResponse
 */
export interface BestSellingFullResponse {
    /**
     * 
     * @type {number}
     * @memberof BestSellingFullResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof BestSellingFullResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof BestSellingFullResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof BestSellingFullResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof BestSellingFullResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof BestSellingFullResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof BestSellingFullResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<BestSellingItem>}
     * @memberof BestSellingFullResponse
     */
    data?: Array<BestSellingItem>;
    /**
     * 
     * @type {Related}
     * @memberof BestSellingFullResponse
     */
    related?: Related;
}

/**
 * Check if a given object implements the BestSellingFullResponse interface.
 */
export function instanceOfBestSellingFullResponse(value: object): value is BestSellingFullResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function BestSellingFullResponseFromJSON(json: any): BestSellingFullResponse {
    return BestSellingFullResponseFromJSONTyped(json, false);
}

export function BestSellingFullResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BestSellingFullResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(BestSellingItemFromJSON)),
        'related': !exists(json, 'related') ? undefined : RelatedFromJSON(json['related']),
    };
}

export function BestSellingFullResponseToJSON(value?: BestSellingFullResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(BestSellingItemToJSON)),
        'related': RelatedToJSON(value.related),
    };
}

